// 展區二（法水長流細部地圖）的桌位序號與四大分區對應規則。
// 由 ZoneDetailMap.jsx（地圖顯示）與 TransmissionDetailPage.jsx（報導頁反查定位）共用，
// 避免兩處各自定義 range 造成不同步。

// table 的序號（table1 -> 1）與後端 coordinate_id 一致
export const coordinateIdToTableId = (coordinateId) => `table${coordinateId}`

// 四大分區：法/水/常/流，依 table 序號範圍對應右下/右上/左上/左下
// label 固定使用中文，不走 i18n（不論介面語言，地圖分區都顯示法水長流）
export const ZONES = [
  { id: 'fa', label: '法', range: [58, 81] },
  { id: 'shui', label: '水', range: [20, 41] },
  { id: 'chang', label: '長', range: [1, 19] },
  { id: 'liu', label: '流', range: [42, 57] },
]

// 依 coordinate_id 找出所屬分區 id
export function findZoneByCoordinateId(coordinateId) {
  const zone = ZONES.find(({ range: [start, end] }) => coordinateId >= start && coordinateId <= end)
  return zone?.id ?? null
}
